import { useState, useEffect, useRef } from "react";

type Term = { [key: string]: any } | string | number | boolean;

export const useDebounce = (fn: (data: Term) => void, time = 300) => {
  const timeout = useRef<NodeJS.Timeout>();

  const [term, setTerm] = useState<Term>();

  useEffect(() => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => {
      if (term) {
        fn(term);
      }
    }, time);

    return () => {
      timeout.current && clearTimeout(timeout.current);
    };
  }, [term, time]);

  return [setTerm];
};
